module.exports = __webpack_public_path__ + "img/olivier.d9b4ff4e.png";